import React from "react";
import { IdcardOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
// import fuelType from "../../../assets/images/fuel-type.png"

const keepInMindContent = () => {
  return (
    <section className="keep-in-mind">
      <div className="keep-title">Keep In Mind</div>
      <div className="keep-content-wrap">
        <div className="precautions">
          <div className="left">
            <IdcardOutlined />
          </div>
          <div className="right">
            <span className="mandatory">Driving License Mandatory</span>
          </div>
        </div>

        <div className="precautions">
          <div className="left">
            <IdcardOutlined />
          </div>
          <div className="right">
            <span className="info">Fare & Fuel Policy</span>
            <p className="keep-details">
              Fare is inclusive of all taxes. Kindly return the car at the same
              fuel level as the trip start time
            </p>
            <Link className="see-deatil" to="/policycontent">Read more</Link>
          </div>
        </div>

        {/* <div className="precautions">
          <div className="left">
            <img className="anticon-img" src={fuelType} alt="fuel"  />
          </div>
          <div className="right">
            <span className="info">Fare & Fuel Policy</span>
            <p className="keep-details">
              Fare is inclusive of all taxes. Kindly return the car at the same
              fuel level as the trip start time
            </p>
            <Link className="see-deatil" to="">Read more</Link>
          </div>
        </div> */}

        <div className="precautions">
          <div className="left">
            <IdcardOutlined />
          </div>
          <div className="right">
            <span  className="info">Cancellation Policy</span>
            <p className="keep-details">
              Hassle free cancellations and refunds at nominal charges
            </p>
            <Link className="see-deatil" to="/policycontent">Read more</Link>
          </div>
        </div>

        <div className="precautions">
          <div className="left">
            <IdcardOutlined />
          </div>
          <div className="right">
            <span  className="info">Agreement Policy</span>
            <p className="keep-details">
              I hereby agree to the terms and conditions of the Lease Agreement
              with Host
            </p>
            <Link className="see-deatil" to="/policycontent">Read more</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default keepInMindContent;
